import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const ViewportContainer = styled.div`
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  pointer-events: none;
  z-index: ${themeStyle.zIndexM1};
`;

export const PageBlocker = styled.div`
  width: 100%;
  height: ${(theme) => theme.height || '80vh'};
  display: flex;
  align-items: center;
`;

export const Message = styled.p`
  font-weight: ${themeStyle.fontSize12};
  font-size: ${themeStyle.fontSize14};
  line-height: 175%;
  color: ${themeStyle.varInkMedium};

  margin: 150px auto;
  max-width: 400px;
  text-align: center;
`;

export const Hide = styled.div`
  opacity: ${({ hide }) => (hide ? '0' : '1')};
`;

export const Above = styled.div`
  z-index: ${({ zIndex }) => zIndex};
`;

export const ScrollButtonBase = styled.button`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 35px;
  height: 35px;
  top: 50%;
  background: ${themeStyle.varBackgroundAlt};
  outline: none;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  filter: ${themeStyle.varFilterShadowHeavy};

  transform: translate(
    ${({ align }) => (align === 'right' ? '50%' : '-50%')},
    -50%
  );
`;
